(function loginBrowserControlModuleDefinition() {
    'use strict';

    angular.module('LoginBrowserControl', [])
        .directive('loginBrowserControl', [ '$uibModal',
            function ( $modal) {
                return {
                    link: function (scope, element, attrs) {
                    },
                    controller: [
                        '$scope', '$element', function ($scope) {
                            $scope.load = function () {
                                $scope.aux = true;
                                var browserName = "";
                                var majorVersion = 0;                             

                                navigator.sayswho = (function () {
                                    var ua = navigator.userAgent, tem,
                                        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                                    if (/trident/i.test(M[1])) {
                                        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                                        browserName = 'IE';
                                        majorVersion = (tem[1] || '');
                                        return;

                                    }
                                    if (M[1] === 'Chrome') {
                                        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                                        if (tem != null) {
                                            browserName = tem[1];
                                            majorVersion = tem[2];
                                            return;
                                        };
                                    }
                                    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                                    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
                                     browserName = M[0];
                                     majorVersion = M[1];
                                })();
                                if ((browserName === 'Chrome' && majorVersion < 60)
                                    || (browserName === 'OPR' && majorVersion < 37)
                                    || (browserName === 'Firefox' && majorVersion < 55)
                                    || (browserName === 'Edge' && majorVersion < 15)
                                    || (browserName === 'Safari' && majorVersion < 11)
                                    || (browserName === 'IE')) {
                                    var modalInstance = $modal.open({
                                        templateUrl: '/app/directives/login-browser-control/login-browser-control.html',
                                        size: 'lg',
                                        backdrop: 'static',
                                        keyboard: false,
                                        windowClass : 'browser',
                                        resolve: {
                                            aux: function () {
                                                return $scope.aux;
                                            }
                                        },
                                        controller: [
                                            '$scope', function ($scope) {
                                                $scope.ok = function () {
                                                    modalInstance.close(true);
                                                }
                                            }]
                                    });

                                }
                            };
                            $scope.load();
                        }],
                    restrict: 'E'
                };
            }
        ]);
})();